import { message, Upload, UploadProps } from 'antd';
import { useTranslation } from 'react-i18next';
import ImgCrop from 'antd-img-crop';
import { useKeycloak } from 'all-in-one-react-keycloak';
import { getConfig } from 'configs';
import Compressor from 'compressorjs';

interface AvatarUploadProps {
  memberType?: string;
  child: React.ReactNode;
  onUploadComplete: () => void;
}

const { baseApiUrl } = getConfig(process.env.REACT_APP_ENVIRONMENT ?? 'development');
const uploadProfileAvatarUrl = `${baseApiUrl}/xapi/v1/user/setting/profile-image`;

export const AvatarUpload = ({ child, onUploadComplete, memberType }: AvatarUploadProps) => {
  const { t } = useTranslation();
  const { keycloak } = useKeycloak();

  const props: UploadProps = {
    name: 'file',
    action: memberType ? uploadProfileAvatarUrl + `?memberType=${memberType}` : uploadProfileAvatarUrl,
    headers: {
      authorization: 'Bearer ' + keycloak.token,
      accept: 'application/json',
    },
    showUploadList: false,
    onChange(info) {
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === 'done') {
        message.success(t('profile.profilePicture.updateSuccess'));
        onUploadComplete();
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} ${t('profile.error.uploadImage')}`);
      }
    },
  };

  return (
    <ImgCrop
      modalTitle={t('profile.profilePicture.editImage')}
      modalOk={t('common.ok')}
      modalCancel={t('common.cancel')}
      rotationSlider
      beforeCrop={(file) => {
        return !!file;
      }}
    >
      <Upload
        beforeUpload={async (file) => {
          const resizeImg = new Promise<File | Blob>((resolve, reject) => {
            new Compressor(file, {
              maxWidth: 200,
              quality: 0.5,
              success: (res) => {
                resolve(res);
              },
              error: (err) => {
                reject(err);
              },
            });
          });

          return await resizeImg;
        }}
        {...props}
      >
        {child}
      </Upload>
    </ImgCrop>
  );
};
